import { track } from '../../features/analytics/analytics';
import { useLocation } from 'react-router-dom';

/**
 * Floating WhatsApp button (SRS §4.2, F-011). Opens a chat with a prefilled message.
 * The number is injected at build time (VITE_WHATSAPP_NUMBER); the button is hidden
 * when unset so it never links to a broken chat.
 */
export function WhatsAppFab(): JSX.Element | null {
  const { pathname } = useLocation();
  const number = import.meta.env.VITE_WHATSAPP_NUMBER;
  if (!number || pathname.startsWith('/products/') || pathname === '/checkout') return null;

  const href = `https://wa.me/${number}?text=${encodeURIComponent(
    "Hello SkyTech Solutions, I'd like to ask about a product.",
  )}`;

  return (
    <a
      href={href}
      onClick={() => track('contact_click', { contact_method: 'whatsapp' })}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="whatsapp-support mx-auto mt-6 inline-flex min-h-11 items-center justify-center gap-3 rounded-full bg-green-700 px-5 py-3 text-white md:fixed md:bottom-5 md:right-5 md:z-40 md:mt-0 md:h-14 md:w-14 md:p-0 md:shadow-hover"
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="#fff" aria-hidden>
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 004.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.16c-.24.68-1.42 1.32-1.95 1.36-.5.04-.97.28-3.28-.68-2.77-1.09-4.5-3.94-4.64-4.13-.13-.19-1.11-1.48-1.11-2.82s.7-2 .95-2.28c.24-.28.53-.35.71-.35.18 0 .36 0 .51.01.16.01.38-.06.6.46.24.56.79 1.94.86 2.08.07.14.12.31.02.5-.09.19-.14.31-.28.48-.14.17-.29.37-.42.5-.14.14-.28.29-.12.56.16.28.71 1.17 1.53 1.9 1.05.94 1.94 1.23 2.21 1.37.28.14.44.12.6-.07.18-.21.7-.81.89-1.09.18-.28.37-.23.6-.14.24.09 1.53.72 1.79.85.26.14.44.21.5.32.06.11.06.65-.18 1.33z" />
      </svg>
      <span className="text-sm font-medium md:sr-only">Ask us on WhatsApp</span>
    </a>
  );
}
